import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        textAlign: 'left',
        textTransform: 'capitalize',
        border: '1px solid #E8EAF4',
        borderRadius: '14px',
        padding: '0.8rem',
        margin: '0.5rem',
        transition: '0.25s ease-in-out',
    },
    text: {
        flex: '1 1 50%',
    },
});

const ListLoading = () => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Skeleton height={'32px'} style={{ flex: '0 0 18px', margin: '12px' }} />
            <div className={classes.text}>
                <Skeleton />
                <Skeleton />
            </div>
        </div>
    );
};

export default ListLoading;
